import { ColumnFilter } from '@tanstack/react-table';
import { isBoolean, isPlainObject, snakeCase } from 'lodash';

import { Filter, FilterType } from '../../_openapi/portfolio-optimizer';
import { NumberFilterValue } from './NumberFilter';

export const parseFilterStringToObject = (value: string) => {
    let parsed;
    try {
        parsed = JSON.parse(decodeURIComponent(value));
    } catch (ex) {
        /** expected error, noop */
    }

    return isPlainObject(parsed) ? parsed : undefined;
};

export const processFilter = (columnFilter: ColumnFilter): Filter => {
    const { id, value } = columnFilter;

    if (Array.isArray(value)) {
        return {
            field: snakeCase(id),
            type: FilterType.LIST,
            value: value.map((v) => ({
                field: snakeCase(id),
                type: FilterType.STRING,
                value: v,
            })),
        };
    }

    const parsed = isPlainObject(value) ? value : parseFilterStringToObject(value as string);
    if (parsed) {
        if (isDateFilter(parsed)) {
            return {
                field: snakeCase(id),
                type: FilterType.DATE,
                value: parsed,
            };
        }

        const numberFilterValues = parsed as NumberFilterValue;
        return {
            field: snakeCase(id),
            type: FilterType.NUMBER,
            value: {
                eq: numberFilterValues.eq ? Number(numberFilterValues.eq) : undefined,
                lt: numberFilterValues.lt ? Number(numberFilterValues.lt) : undefined,
                lte: numberFilterValues.lte ? Number(numberFilterValues.lte) : undefined,
                gt: numberFilterValues.gt ? Number(numberFilterValues.gt) : undefined,
                gte: numberFilterValues.gte ? Number(numberFilterValues.gte) : undefined,
                mode: numberFilterValues.mode,
            },
        };
    }

    const bool = isBoolean(value) || value === 'true' || value === 'false';
    return {
        field: snakeCase(id),
        type: bool ? FilterType.BOOLEAN : FilterType.STRING,
        value: bool ? value === 'true' || value === true : value,
    };
};

export const isDateFilter = (value: unknown) => {
    return Object.prototype.hasOwnProperty.call(value, 'from') || Object.prototype.hasOwnProperty.call(value, 'to');
};
